// extracted by mini-css-extract-plugin
export default {"tooltipIcon":"Tooltip_tooltipIcon__m0Fvb","tooltipContent":"Tooltip_tooltipContent__K94Td"};